import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthData } from '../core/data';
import { MessageService } from 'primeng/api';
import { LocalStorageService } from '../core/services/shared-services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SalesGuard  {
  constructor(
    private authServiceApi: AuthData,
    private router: Router,
    private localStorageService: LocalStorageService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authServiceApi.isLoggedIn()) {
      if (this.localStorageService.getItem("user") != null) {
        const userRole = this.authServiceApi.getRole();
        if (userRole?.toLowerCase() == "admin") {
          this.router.navigate(["/admin/dashboard"]);
        } else {
          this.router.navigate(["/selfcare/dashboard"]);
        }
      }
      return false;

    } 
    return true;

  }
}
